import React, { Component } from 'react';
import MarkdownScript from 'helpers/markdownScript';
import dataUsagePolicy from './auth/dataUsage.md';

const md = new MarkdownScript(dataUsagePolicy);

export default class DataUsage extends Component {

  render () {
    return (
      <div>
        <div dangerouslySetInnerHTML={{__html: md.getAllAsHtml()}} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/dataUsage.jsx